import { createRouter, createWebHashHistory } from 'vue-router'

const LoginPage = () => import(
  /* webpackChunkName: "route-auth", webpackPrefetch: true */
  '../components/Login.vue'
)
const RegisterPage = () => import(/* webpackChunkName: "route-auth" */ '../components/Register.vue')
const ResetPasswordPage = () => import(/* webpackChunkName: "route-auth" */ '../components/ResetPassword.vue')
const CarListPage = () => import(/* webpackChunkName: "route-carlist" */ '../components/CarList.vue')

const routes = [
  {
    path: '/',
    redirect: '/carlist'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/resetpwd',
    name: 'ResetPassword',
    component: ResetPasswordPage
  },
  {
    path: '/carlist',
    name: 'CarList',
    component: CarListPage
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/carlist'
  }
]

const router = createRouter({
  history: createWebHashHistory('/pastel/'),
  routes
})

// 车队页空闲时提前解析登录页分包，避免第一次点击才下载 CSS/JS。
export const preloadLoginPage = LoginPage

export default router
